export const DIALOG_PAPER_SX = {
    borderRadius: 3,
    "@media (max-width: 599.95px)": { borderRadius: 0 },
};
export const DIALOG_TITLE_SX = {
    fontWeight: 700,
    fontSize: 18,
    pb: 1.5,
};
export const DIALOG_ACTIONS_SX = {
    px: 3,
    pb: 2.5,
    pt: 1,
    gap: 1,
};
